<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" :fill="color">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.977 17.91c-.24 0-.472-.052-.696-.157a2.88 2.88 0 0 1-.652-.427l-8.09-8.09C2.18 8.876 2 8.426 2 7.888c0-.54.18-.99.54-1.349C2.898 6.18 3.332 6 3.841 6c.51 0 .944.18 1.303.54l6.832 6.831L18.81 6.54A1.8 1.8 0 0 1 20.134 6c.525 0 .967.18 1.327.54.36.359.539.801.539 1.326s-.18.967-.54 1.327l-8.134 8.133c-.18.18-.39.322-.63.427a1.771 1.771 0 0 1-.719.157z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps<{ color?: string }>();
</script>
